import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Info } from "lucide-react";
export default function SellYourMotorcycleFastAndSafe() {
  return <section data-section-id="247360" id="hero" className="relative w-full py-24 md:py-32 lg:py-40 overflow-hidden bg-gradient-to-r from-secondary to-secondary/90 bg-background text-foreground">
            {}
            <div className="absolute inset-0 bg-black/20 pointer-events-none"></div>
            
            <div className="container relative z-10 px-4 md:px-6 mx-auto text-center">
                <div className="max-w-4xl mx-auto space-y-8">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-white drop-shadow-lg tracking-tight">
                        Professional Mold Testing & Inspection
                    </h1>
                    
                    <p className="text-lg md:text-xl lg:text-2xl text-white/90 font-default max-w-2xl mx-auto drop-shadow-sm">
                        Protect your health and property with certified air quality assessments in South Florida.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
                        <Button asChild size="lg" className="w-full sm:w-auto text-base font-bold bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl h-14 px-8 rounded-md border-2 border-transparent hover:border-white/20 transition-all">
                            <Link to="/MoldTestingPage">
                                Schedule Testing
                                <ArrowRight className="ml-2 size-5" />
                            </Link>
                        </Button>
                        
                        <Button asChild size="lg" variant="outline" className="w-full sm:w-auto text-base font-bold bg-transparent text-white border-2 border-white hover:bg-white hover:text-secondary shadow-xl h-14 px-8 rounded-md transition-all">
                            <Link to="/FourPointInspectionSouthFloridaPage">
                                <Info className="mr-2 size-5" />
                                Our Process
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>;
}